// path: src/your-path/hooks/useMarketplaceAccount.js
import { useState } from 'react';
import useMarketPlaceModal from "../MarketPlaceModal/useMarketPlaceModal";

const useMarketplaceAccount = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenLoading, setModalOpenLoding] = useState(false);
  const [selectedBadge, setSelectedBadge] = useState(null);
  const { loading, handleConnect, marketplaceData, getMarketplaces } = useMarketPlaceModal();

  const handleBadgeClick = (name) => {
    setSelectedBadge(name);
    setModalOpen(true);
  };

  const handleConfirm = async () => {
    setModalOpen(false);
    setModalOpenLoding(true);
    try {
      const result = await handleConnect(selectedBadge);
      if (result?.success) {
        setModalOpenLoding(false);
      }
    } catch (error) {
      console.error("Connection failed:", error);
    }
  };

  const handleCancel = () => {
    setModalOpen(false);
  };

  return {
    modalOpen,
    selectedBadge,
    handleBadgeClick,
    handleConfirm,
    handleCancel,
    modalOpenLoading,
    setModalOpenLoding
  };
};

export default useMarketplaceAccount;
